module.exports = __webpack_public_path__ + "media/post-registration/explore@2x-04da3b28.png";